import { render } from "./supernatant.vue?vue&type=template&id=4472184a&scoped=true"
import script from "./supernatant.vue?vue&type=script&lang=js"
export * from "./supernatant.vue?vue&type=script&lang=js"

import "./supernatant.vue?vue&type=style&index=0&id=4472184a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4472184a"

export default script